import {useState} from 'react';
import {useGA4WithParams} from '@/hooks/tracking';
import {RankingBoard} from '../../RankingBoard';
import {Menu} from '../Menu';
import {ButtonContainer} from '../StyledComponents';
import Icon from './icon-ranking.svg';

export const RankingButton = () => {
  const [open, setOpen] = useState<boolean>(false);
  const tracking = useGA4WithParams();

  const toggle = () => {
    setOpen((prev) => {
      const next = !prev;

      if (next) {
        tracking('rankingboard_open');
      }

      return next;
    });
  };

  if (open) {
    return <RankingBoard onClose={toggle} />;
  }

  return (
    <ButtonContainer>
      <Menu icon={Icon} label="랭킹보드" onClick={toggle} />
    </ButtonContainer>
  );
};
